import * as Yup from 'yup'

export const notifyEventSchema = Yup.object().shape({
    date_incident: Yup.date().required('Data do incidente é obrigatória'), //essas mensagens nao estão sendo usadas esta usando a mensagem padrão
    incident_title: Yup.string().required('Título do incidente é obrigatório'),
    incident_description: Yup.string().required(
        'Descrição do incidente é obrigatória'
    ),
    immediate_corrective_action: Yup.string().required(
        'Ação corretiva imediata é obrigatória'
    ),
    incident_type: Yup.string().required('Tipo do incidente é obrigatório'),
    u_categorized_contributing_factor: Yup.string().notRequired(),
    damage_level: Yup.string().required('Classificação do Incidente é obrigatório'),
    involves_patient: Yup.boolean(),

    patient_initials: Yup.string().when(['involves_patient', 'u_number_patients_involved'], {
        is: (involvedPatient, numberPatients) =>  involvedPatient === true && numberPatients === "um_paciente",
        then: (schema) => schema.required('Nome completo é obrigatório'),
        otherwise: (schema) => schema.notRequired()
    }),
    patient_date_of_birth: Yup.date().when(['involves_patient', 'u_number_patients_involved'], {
        is: (involvedPatient, numberPatients) =>  involvedPatient === true && numberPatients === "um_paciente",
        then: (schema) => schema.required('Nome completo é obrigatório'),
        otherwise: (schema) => schema.notRequired()
    }),
    document_type: Yup.string().when(['involves_patient', 'u_number_patients_involved'], {
        is: (involvedPatient, numberPatients) =>  involvedPatient === true && numberPatients === "um_paciente",
        then: (schema) => schema.required('Nome completo é obrigatório'),
        otherwise: (schema) => schema.notRequired()
    }),
    document_number: Yup.string().when(['involves_patient', 'u_number_patients_involved'], {
        is: (involvedPatient, numberPatients) =>  involvedPatient === true && numberPatients === "um_paciente",
        then: (schema) => schema.required('Nome completo é obrigatório'),
        otherwise: (schema) => schema.notRequired()
    }),
    patient_gender: Yup.string().when(['involves_patient', 'u_number_patients_involved'], {
        is: (involvedPatient, numberPatients) =>  involvedPatient === true && numberPatients === "um_paciente",
        then: (schema) => schema.required('Gênero é obrigatório'),
        otherwise: (schema) => schema.notRequired()
    }),
    location_incident: Yup.string().required(
        'Hospital onde o evento ocorreu é obrigatório'
    ),
    incident_sector: Yup.string().required('Setor notificado é obrigatório'),
    shift_incident: Yup.string().required(
        'Turno que o evento ocorreu é obrigatório'
    ),
    reporter_sector: Yup.string().required('Setor notificante é obrigatório'),
    notification_type_toggle: Yup.boolean(),
    notification_type: Yup.string().notRequired(),

    reporter_name: Yup.string().when('notification_type_toggle', {
        is: true,
        then: (schema) => schema.required('Nome completo é obrigatório'),
        otherwise: (schema) => schema.notRequired()
    }),
    u_number_patients_involved: Yup.string()
    .when('involves_patient', {
        is: true,
        then: (schema) =>
            schema.required('Pacientes relacionados é obrigatório'),
        otherwise: (schema) => schema.notRequired()
    }),
    u_notification_multiplier: Yup.string().notRequired(),
    u_attachments_url: Yup.string(),
    u_attachments_string: Yup.string(),
    u_attachments_size: Yup.string(),
    u_version: Yup.string()
})

export type NotifyEventType = Yup.InferType<typeof notifyEventSchema>
